import { useSelector } from 'react-redux';
import { useState, useEffect, useMemo } from 'react';
import { AppState } from '../../../redux/modules/store';
import { FilterItem } from '../../../redux/reducers/StoreFilterReducer';
import { hasForbiddenCharacter } from '../../ValidationCheck';
import { ProhibitedWordInfo } from '../../../external/MasterProhibitedWordApi';

export const MSG_ERR = {
  requiredMsg: 'フィルタ名は必須項目です',
  prohibitMsg: '使用できない文字が含まれています',
  limitMsg: '15文字以内で入力してください',
  noActiveMsg: '店舗を選択してください',
  duplicateMsg: 'フィルタ名が重複しています',
  limitItemMsg: 'フィルタの数が上限です。',
  requiredFilterNameAndStore: 'フィルタ名と店舗は必須項目です',
};

export const LIMIT_WORDS = 15;
export const LIMIT_FILTER_ITEMS = 30;

const useValidateFilterName = (itemActive: FilterItem, isCreate?: boolean): string => {
  const { prohibitedWordMstList } = useSelector((state: AppState) => state.masterInfo);
  const { cloneData } = useSelector((state: AppState) => state.filterStore);
  const [err, setSerr] = useState<string>('');
  const isLimitFilterItem = useMemo(() => {
    return LIMIT_FILTER_ITEMS === cloneData.length && !!isCreate;
  }, [cloneData, isCreate]);

  useEffect(() => {
    const errorMsg = getClientErrorMsg({
      itemActive,
      cloneData,
      prohibitedWordMstList,
      isLimitFilterItem,
    });
    setSerr(errorMsg);
  }, [itemActive, cloneData, prohibitedWordMstList, isLimitFilterItem]);
  return err;
};

interface IClientErrorMsg {
  itemActive: FilterItem;
  cloneData: FilterItem[];
  prohibitedWordMstList: ProhibitedWordInfo[];
  isLimitFilterItem: boolean;
}
export function getClientErrorMsg({ itemActive, cloneData, prohibitedWordMstList, isLimitFilterItem }: IClientErrorMsg) {
  const filterName = itemActive.filterName.trim();
  const prohibitWords = prohibitedWordMstList.filter((v) => v.isProhibitedChar).map((v) => v.prohibitedWord);
  const checkDuplicateFilterName = cloneData.findIndex(
    (item) => item.filterID !== itemActive.filterID && item.filterName === itemActive.filterName
  );

  if (isLimitFilterItem) return MSG_ERR.limitItemMsg;
  if (checkDuplicateFilterName !== -1) return MSG_ERR.duplicateMsg;
  if (!filterName.length) {
    if (!itemActive.ordcstmCdList.length) {
      return MSG_ERR.requiredFilterNameAndStore;
    }
    return MSG_ERR.requiredMsg;
  }
  if (filterName.length > LIMIT_WORDS) return MSG_ERR.limitMsg;
  if (hasForbiddenCharacter(filterName, prohibitWords)) return MSG_ERR.prohibitMsg;
  if (!itemActive.ordcstmCdList.length) return MSG_ERR.noActiveMsg;
  return '';
}

export default useValidateFilterName;
